import INotificationRepository from '../../2_domain/notification/iNotificationRepository';
import {
  notificationFromDto,
  NotificationHistory,
} from '../../2_domain/notification/notification';
import Connection2 from '../core/connection2';

class NotificationRepository implements INotificationRepository {
  //LINK - id 33
  readNotification = async (id: number): Promise<NotificationHistory> => {
    const { code, ...res } = await Connection2.requestPost(
      'clinic/pass/queryClinicNotificationHistoryDetail',
      { id }
    );
    return notificationFromDto(res);
  };

  //LINK - id 34
  //NOTE - pagination
  getNotificationHistories = async (
    pagination: Pagination
  ): Promise<NotificationHistory[]> => {
    const { list } = await Connection2.requestPost(
      'clinic/pass/queryClinicNotificationHistoryList',
      {
        openFlag: 'ALL',
        pageNumber: 0,
        pageSize: 20,
      }
    );

    return list.map(notificationFromDto);
  };

  //LINK - id 34
  //NOTE - pagination
  getNewNotificationHistories = async (): Promise<boolean> => {
    const { list } = await Connection2.requestPost(
      'clinic/pass/queryClinicNotificationHistoryList',
      {
        openFlag: 'NOT_OPENED',
        pageNumber: 0,
        pageSize: 1,
      }
    );
    return !!list?.length;
  };
}

export default NotificationRepository;
